import styled from 'styled-components';

export const PriceContainer = styled.div`
    display: flex;
    > div {
        flex: 1;
    }
    gap: 16px;
`;